export const initialState = {
  isEditing: false, // Flags when the user is writing a comment
  comment: '',
  mapControls: {
    boundingBox: true,
    submittedPolygon: true,
    processedPolygon: true,
  },
  mapLayers: {
    boundingBox: null,
    submittedPolygon: null,
    processedPolygon: null,
  },
  map: null,
};

export const calculateBoundsCenter = bounds => ({
  lat: (bounds.north + bounds.south) / 2,
  lng: (bounds.east + bounds.west) / 2,
});
